import { useQuery } from "@tanstack/react-query"
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService"
import { ConsolidatedWorker } from "./@types"



const fetch = async () => {
    const { data } = await apiInputService.get('/consolidatedWorkers')

    return data as ConsolidatedWorker[]
}

export const useConsolidatedWorkers = ( options?: any) => {
    const {subscription} = useSubscription();

    return useQuery(
        ['consolidatedWorkers', subscription?.subscriptionId],
        fetch,
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            enabled: !!subscription?.subscriptionId,
            ...options
        }
    )
}